import TrowelIcon from "../icon";
import TrowelSearch from "../inputs/search";
import "./index.scss";
import gearIcon from "../../assets/media/icons/gearIcon.png";
import helpIcon from "../../assets/media/icons/helpIcon.png";
//import commentIcon from "../../assets/media/icons/commentIcon.png";
import feedbackIcon from "../../assets/media/icons/feedbackIcon.png";
import defaultAvatarImage from "../../assets/media/icons/avatar.png";
import Avatar from "../avatar";
import { IUserSessionInfo, userSessionStateSelector } from "../../redux/reducers/user-session/userSessionSlice";
import { useAppSelector } from "../../hooks/typed-hooks";
import { useEffect, useState, useRef } from "react";
import FeedbackForm from "../feedback-form/feedback-form";
import { useNavigate } from "react-router-dom";
import ContactSupportForm from "../contact-support/contact-support";

const TrowelHeader: React.FC = () => {

  const selectUserSessionInfo = useAppSelector(userSessionStateSelector);
  const [userInfo, setUserInfo] = useState<IUserSessionInfo| null>(null);

  const navigate = useNavigate();
  useEffect(()=>{

    console.log("User session infor inside header ", selectUserSessionInfo);
    setUserInfo(selectUserSessionInfo);

  }, [selectUserSessionInfo]);
  
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const profileMenuRef = useRef<HTMLDivElement>(null);

  const handleFeedbackClick = () => {
    setIsFeedbackOpen(true);
  };

  const closeFeedbackForm = () => {
    setIsFeedbackOpen(false);
  };

  const handleNavigateToHomeClick = () => {
    navigate("/");
  };

  const handleHelpIconClick = () => {
    setIsHelpOpen(true);
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const handleLogout = () => {
    // Clear session storage
    sessionStorage.removeItem('auth_info');
    sessionStorage.removeItem('session_id');
    
    // Clear any other stored tokens or user data
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    
    console.log("User logged out successfully");
    
    // Close the menu
    setIsProfileMenuOpen(false);
    
    // Redirect to landing page
    navigate('/');
  };

  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target as Node)) {
        setIsProfileMenuOpen(false);
      }
    };

    if (isProfileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProfileMenuOpen]);

  return (
    <header className="trwl-header">
      <div className="header-item ">
        <span className="trwl-logo_header__icon" onClick={handleNavigateToHomeClick}></span>
        {/* <span className="trwl-logo__text" onClick={handleNavigateToHomeClick}>TROWEL.AI</span> */}
      
      </div>
      {/* <div className="header-item">
        <TrowelSearch/>
      </div> */}
      <div className="header-item icon-group" >
        <div className="chat-connect" onClick={handleFeedbackClick}>
          <TrowelIcon src={feedbackIcon} className="chat-connect-icon" width="1.5rem" height="1.5rem"/>
          <span className="chat-connect__text">Feedback</span>
        </div>

        <TrowelIcon src={helpIcon} className="header-icon help-icon" onClick={handleHelpIconClick}/>
        <TrowelIcon src={gearIcon} className="header-icon" />
        <div className="profile-menu-container" ref={profileMenuRef}>
          <span title={userInfo?.name} onClick={toggleProfileMenu} style={{ cursor: 'pointer' }}>
            <Avatar src={userInfo?.profileImage || defaultAvatarImage} width="2.5rem" height="2.5rem"/>
          </span>
          {isProfileMenuOpen && (
            <div className="profile-dropdown-menu">
              <div className="profile-menu-header">
                <Avatar src={userInfo?.profileImage || defaultAvatarImage} width="3rem" height="3rem"/>
                <div className="profile-info">
                  <div className="profile-name">{userInfo?.name || 'User'}</div>
                  <div className="profile-email">{userInfo?.email || ''}</div>
                </div>
              </div>
              <div className="profile-menu-divider"></div>
              <div className="profile-menu-items">
                {userInfo?.firmId && (
                  <div className="profile-menu-item">
                    <i className="bi bi-building"></i>
                    <span>Firm ID: {userInfo.firmId}</span>
                  </div>
                )}
                {userInfo?.id && (
                  <div className="profile-menu-item">
                    <i className="bi bi-person-badge"></i>
                    <span>User ID: {userInfo.id}</span>
                  </div>
                )}
              </div>
              <div className="profile-menu-divider"></div>
              <div className="profile-menu-actions">
                <button className="profile-menu-action-btn" onClick={() => navigate('/profile')}>
                  <i className="bi bi-person-circle"></i>
                  <span>View Profile</span>
                </button>
                <button className="profile-menu-action-btn" onClick={() => navigate('/settings')}>
                  <i className="bi bi-gear"></i>
                  <span>Settings</span>
                </button>
                <button className="profile-menu-action-btn logout" onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right"></i>
                  <span>Logout</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {isFeedbackOpen && <FeedbackForm onClose={closeFeedbackForm} />}
      {isHelpOpen && ( <ContactSupportForm onClose={() => setIsHelpOpen(false)} /> )}
    </header>
  );
};

export default TrowelHeader;
